/* Angular Component */
import { Component, Input, OnInit } from "@angular/core";
import { IndicateStatus } from "../../../domain/enums";

const THEMES = {
  MI: "MI",
  DARK: "DARK",
  BR: "BR",
  GREEN: "GREEN",
  ICON: "IC",
  DISABLED: "DIS",
  WHITE: "WHITE",
  LOADING: "LOADING",
  WARNING: "WARNING",
  BLACK: "BLACK",
};

const ICONS = {
  SORT: "SORT",
};

@Component({
  selector: "ichannel-button",
  templateUrl: "./button.component.html",
  styleUrls: ["./button.component.scss"],
})
export class ButtonComponent {
  @Input()
  label;

  @Input()
  icon;

  @Input()
  clickable = true;

  @Input()
  theme;

  @Input()
  callback;

  @Input()
  reactive = false;

  @Input()
  customButtonStyle: Object;

  themes;
  icons;

  ngOnInit() {
    this.themes = THEMES;
    this.icons = ICONS;
  }

  getIconClass() {}

  /**
   * Button Listener
   * @param $event
   */
  onClick(event) {
    if (typeof this.callback == "function") this.callback();
  }
}
